import Bowser from 'bowser'

const BOWSER_RESULTS = Bowser.parse(window.navigator.userAgent)

const osVersion = BOWSER_RESULTS.os.version
const osName = BOWSER_RESULTS.os.name
const osVersionName = BOWSER_RESULTS.os.versionName
const browserName = BOWSER_RESULTS.browser.name
const browserVersion = BOWSER_RESULTS.browser.version

export const deviceInfo = {
  osVersion,
  osName,
  osVersionName,
  browserName,
  browserVersion,
}
